require("@fontsource/inter/latin-300.css")
require("@fontsource/inter/latin-400.css")
require("@fontsource/inter/latin-600.css")
require("@fontsource/lora/latin-400.css")
require("@fontsource/lora/latin-500.css")
require("@fontsource/lora/latin-600.css")
require("@fontsource/lora/latin-600-italic.css")
require("@fontsource/lora/latin-700.css")
require("@fontsource/lora/latin-700-italic.css")